export const state = {
  factories: [],
  planningFactoryTab: '0',
};

// getters
export const getters = {
  getFactories: (state) => state.factories,
  getPlanningFactoryTab: (state) => state.planningFactoryTab,
};

// Setters
export const actions = {
  setPlanningFactoryTab({ commit }, data) {
    commit('commitPlanningFactoryTab', data);
  },
};

// mutations
export const mutations = {
  commitFactories(state, data) {
    state.factories = data;
  },
  commitPlanningFactoryTab(state, data) {
    state.planningFactoryTab = data;
  },

  /**
   * Update one or more properties on a specific factory.
   *
   * @param object state
   * @param object data
   */
  updateFactoryProperties(state, data) {
    // Update the navigation data.
    state.factories = state.factories.map((factory) => {
      if (factory.id === data.id) {
        return {
          ...factory,
          ...data.update,
        };
      }
      return factory;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
